import { Directive, ElementRef, Input, OnInit, Renderer2, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSpinner]'
})
export class SpinnerDirective implements OnInit {

  private parent: HTMLElement;
  private spinnerInstance: HTMLSpanElement;

  @Input() set appSpinner(loading: boolean) {
    if (loading) {
      this.spinnerInstance = this.createSpinner();
    } else {
      this.destroySpinner();
    }
  }

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) { }

  ngOnInit(): void {
  }

  private createSpinner(): HTMLSpanElement {
    this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');

    const spinner = this.renderer.createElement('span');
    this.renderer.addClass(spinner, 'spinner-border');
    this.renderer.addClass(spinner, 'spinner-border-sm');
    this.renderer.setAttribute(spinner, 'role', 'status');

    this.renderer.appendChild(this.elementRef.nativeElement, spinner);

    return spinner;
  }

  private destroySpinner(): void {
    if (this.spinnerInstance) {
      this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
      this.renderer.removeChild(this.elementRef.nativeElement, this.spinnerInstance);

      this.parent = null;
      this.spinnerInstance = null;
    }
  }

}
